import { render, staticRenderFns } from "./clientFundsStatistics.vue?vue&type=template&id=6ff91942&scoped=true"
import script from "./clientFundsStatistics.vue?vue&type=script&lang=js"
export * from "./clientFundsStatistics.vue?vue&type=script&lang=js"
import style0 from "./clientFundsStatistics.vue?vue&type=style&index=0&id=6ff91942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff91942",
  null
  
)

export default component.exports